module.exports = __webpack_public_path__ + "img/logo_light.d8d21986.png";